import styled from 'styled-components';

export const SolutionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`;

export const SolutionCell = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex: 1;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  background: ${({ theme }) => theme.palette.common.white};
  flex-wrap: wrap;
  @media (max-width: 950px) {
    flex-basis: 100%;
  }
`;

export const SolutionTitle = styled.h3`
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.15px;
  margin: 0 0 10px 0;
`;

export const SolutionDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 8px 0;
  flex: 2;
`;

export const SolutionImage = styled.img`
  width: 100%;
  align-self: center;
  object-fit: fill;
  flex: 1;
`;
